import React from 'react';
import ActionConfirmModal from './ActionConfirmModal';

export default function SessionPromptModal({ message, onConfirm, onCancel }) {
  return (
    <ActionConfirmModal
      open
      title="Active Session"
      message={message}
      confirmLabel="Yes"
      cancelLabel="No"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
